import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import submit from "submit-form";
import PropTypes from "prop-types";
import SvgIcon from "./SvgIcon";
import ToolTip from "./tooltip-portal";

export const PasteExerciseComponent = ({
  athlete,
  date,
  classNames,
  withFullInfo = false,
  showAddExercise,
  isProgram = false,
  sessionProgram,
  programNumber,
  cycle,
  query,
  haveExercises = false,
  exercisesLength = 0,
  highestOrder = 0,
}) => {
  const [exercisesToCopy, setExercisesToCopy] = useState(null);
  const [originalAthleteLibraryToCopy, setOriginalAthleteLibraryToCopy] =
    useState(null);

  /**
   * Get the exercises stored in the local storage
   */
  useEffect(() => {
    if (typeof window !== "undefined") {
      const exerciseInLocalStorage = localStorage.getItem("exercisesToCopy");
      const athleteInLocalStorage = localStorage.getItem(
        "originalAthleteLibraryToCopy"
      );
      try {
        setExercisesToCopy(
          exerciseInLocalStorage ? JSON.parse(exerciseInLocalStorage) : null
        );
        setOriginalAthleteLibraryToCopy(
          athleteInLocalStorage ? JSON.parse(athleteInLocalStorage) : null
        );
      } catch (error) {
        console.error("Error parsing exercisesToCopy:", error);
      }
    }
  }, [query]);

  /**
   * Function to paste the exercises
   * @param {*} e
   */
  const handlePasteExercises = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (exercisesToCopy) {
      const { _id: athleteId, repMaximums: athleteRepMaximums } = athlete;
      const body = {
        athlete: { _id: athleteId, repMaximums: athleteRepMaximums },
        date,
        originalAthleteLibraryToCopy,
        isProgram,
        exercisesLength,
        highestOrder,
        ...(isProgram && {
          cycleId: cycle?._id,
          programNumber,
          sessionProgram,
        }),
      };
      submit(`/actions/exercise/paste-exercises`, {
        method: "POST",
        body,
      });
    }
  };

  const { t } = useTranslation("coaching-portal");

  if (!exercisesToCopy) return null;

  return withFullInfo ? (
    <a
      className={classNames}
      href="#"
      onClick={handlePasteExercises}
      aria-disabled={
        showAddExercise !== undefined ? !showAddExercise : undefined
      }
    >
      <span className="flex h-9 w-9 items-center justify-center rounded-xl border border-solid border-(--white-20)">
        <SvgIcon src="/img/new-icons/paste.svg" className="h-11 w-11" />
      </span>
      <p className="p4 text-center">{t("pasteExercise.pasteWorkout")}</p>
    </a>
  ) : haveExercises ? (
    <ToolTip body={t("pasteExercise.pasteWorkout")}>
      <a
        href="#"
        onClick={handlePasteExercises}
        data-button-type="secondary"
        role="button"
      >
        <SvgIcon src="/img/new-icons/paste.svg" />
      </a>
    </ToolTip>
  ) : (
    <button
      id="button-local-paste"
      className={classNames}
      onClick={handlePasteExercises}
    >
      <SvgIcon src="/img/new-icons/paste.svg" />
    </button>
  );
};

PasteExerciseComponent.propTypes = {
  athlete: PropTypes.object,
  date: PropTypes.string,
  classNames: PropTypes.string,
  withFullInfo: PropTypes.bool,
  showAddExercise: PropTypes.bool,
  isProgram: PropTypes.bool,
  sessionProgram: PropTypes.object,
  programNumber: PropTypes.number,
  cycle: PropTypes.object,
  query: PropTypes.string,
  haveExercises: PropTypes.bool,
  exercisesLength: PropTypes.number,
  highestOrder: PropTypes.number,
};
